<script>
  import { createEventDispatcher, beforeUpdate } from "svelte";
  const dispatch = createEventDispatcher();

  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  const progress = tweened(0, {
    duration: 400,
    easing: cubicOut
  });

  import { fly } from "svelte/transition";
  let questionsVisible = true;

  import { questionsWrite, settings, statistics } from "./store.js";

  import { getNextQuestion, sleepTime, doVoice } from "./functions.js";

  // let nextQuestion = getNextQuestion($questionsWrite, $settings);
  let nextQuestion = null;

  function setFeedback(error) {
    if (document.getElementById("quizbody") != null) {
      if (error)
        document.getElementById("quizbody").style.backgroundColor = "#F2F5A9";
      else document.getElementById("quizbody").style.backgroundColor = "white";
    }
  }

  async function setAnswer(val) {
    questionsVisible = false;

    if (nextQuestion.choices[val] == nextQuestion.val) {
      setFeedback(false);
      nextQuestion.runCount++;
      if (nextQuestion.runCount >= $settings.requiredAnswersPerQuestion)
        nextQuestion.completed = true;
    } else {
      setFeedback(true);
      nextQuestion.runCount--;
      nextQuestion.errors++;
    }

    $questionsWrite.splice(nextQuestion.id - 1, 1, nextQuestion);
    const questions = $questionsWrite;
    questionsWrite.set(questions);

    progress.set(Math.abs($statistics.scorePers) / 100);

    await sleepTime(200);
    nextQuestion = getNextQuestion($questionsWrite, $settings);

    questionsVisible = true;
  }

  function CloseQuiz() {
    dispatch("quizClose");
  }

  let answers = [{ id: 2, key: "2 answers" }];
  let i;
  for (i = 3; i <= $settings.answerChoicesMax; i++) {
    answers.push({ id: i, key: "" + i + " answers" });
  }

  $: if ($settings.quiz == true) {
    if (document.getElementById("quizModal"))
      document.getElementById("quizModal").classList.add("is-active");
    if (nextQuestion == null) {
      nextQuestion = getNextQuestion($questionsWrite, $settings);
      setFeedback(false);
      progress.set(0);
    }
  }

  $: if ($settings.quiz == false) {
    nextQuestion = null;
    if (document.getElementById("quizModal"))
      document.getElementById("quizModal").classList.remove("is-active");
  }

  $: if ($statistics.scorePers < -74) {
    $settings.answerChoicesUpTo = 2;
  }
</script>

<style>
  .qm-pointer {
    cursor: pointer;
  }
  progress {
    display: block;
    width: 100%;
  }
</style>

<div class="modal" id="quizModal">
  <div class="modal-background" />
  {#if nextQuestion}
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title" style="padding-right:5px">
          <table class="table is-fullwidth is-narrow has-background-white-ter">
            <tr>
            <td>
             {#if $settings.inline && $settings.rVoice && $settings.rotate==false}
               <button
                class="button"
                aria-label="close"
                on:click={() => {
                  doVoice(nextQuestion.key, $settings.rCode);
                }}>
                <i class="fas fa-play-circle" />
              </button>
               {/if}
            </td>
              <td style="vertical-align:bottom">
                <div class="select is-small">
                  <select
                    bind:value={$settings.answerChoicesUpTo}
                    on:change={() => {
                      nextQuestion = getNextQuestion($questionsWrite, $settings);
                    }}>
                    {#each answers as answer}
                      <option value={answer.id}>{answer.key}</option>
                    {/each}
                  </select>
                </div>
              </td>
              <td style="vertical-align:bottom">
                <label class="checkbox is-size-6">
                  <input type="checkbox" bind:checked={$settings.inline} />
                  Inline
                </label>
              </td>
            </tr>
          </table>
        </div>

        <button
          class="delete"
          aria-label="close"
          on:click={() => {
            CloseQuiz();
          }} />
      </header>
      <section
        class="modal-card-body"
        style="padding-top:1px;height: 900px;"
        id="quizbody">
        <div style="padding-bottom:30px">
          {#if $settings.inline==false}
            <div
              style="margin:2px; font-size: large;"
              class="box has-background-grey-lighter">
              <span class="has-text-weight-bold ">
               {#if $settings.rVoice && $settings.rotate==false}
               <button
                class="button"
                aria-label="close"
                on:click={() => {
                  doVoice(nextQuestion.key, $settings.rCode);
                }}>
                <i class="fas fa-play-circle" />
              </button>
               {/if}
              {nextQuestion.key}</span>
            </div>
          {/if}
          <p class="has-text-grey is-size-7">Click on a match</p>

          {#if questionsVisible}
            <p transition:fly={{ x: -10, duration: 600 }}>
              {#each nextQuestion.choices as choice, i}
                <div
                  style="margin:5px;font-size: large;"
                  class="box qm-pointer"
                  on:click={() => {
                    setAnswer(i);
                  }}>
                  {#if $settings.inline}
                    <span class="has-text-weight-semibold">
                      {nextQuestion.key}
                    </span>
                    -
                  {/if}
                  {choice}
                </div>
              {/each}
            </p>
          {/if}

        </div>
      </section>
      <footer class="modal-card-foot" style="padding:3px">
        <span class="tag is-small has-text-danger has-text-weight-bold">
          Errors: {$statistics.errors}
        </span>
        <span class="tag is-small has-text-success has-text-weight-bold">
          Score: {$statistics.score}
        </span>
        <span class="tag is-small has-text-link has-text-weight-bold">
          Goal: {$statistics.total}
        </span>
        {#if $statistics.score >= 0}
          <progress value={$progress} />
          <span class="tag is-small has-text-link has-text-weight-bold">
            {$statistics.scorePers}%
          </span>
        {:else}
          <div style="padding:1px; background-color:red; width: 100%; nowrap">
            <progress value={$progress} />
          </div>
          <span class="tag is-small has-text-danger has-text-weight-bold">
            {$statistics.scorePers}%
          </span>
        {/if}
      </footer>
      <footer class="modal-card-foot" style="padding:5px;">

        <button
          class="button is-rounded is-outlined is-medium"
          style="margin: auto;"
          on:click={() => {
            CloseQuiz();
          }}>
          Cancel Quiz
        </button>
      </footer>
    </div>
  {:else}
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-size-3">Quiz Completed</p>
        <button
          class="delete"
          aria-label="close"
          on:click={() => {
            CloseQuiz();
          }} />
      </header>
      <section
        class="modal-card-body has-text-centered"
        style="padding:25px;height: 900px;"
        id="quizbody">
        {#if $statistics.errors == 0}
          <div class="notification is-primary">
            <p class="title is-size-3">Congratulations!!</p>
            <p class="title is-size-4">
              You have completed the quiz with no errors.
            </p>
          </div>
        {:else}
          <div class="notification is-warning">
            <p class="title is-size-4">
              You have completed the quiz with errors. Review errors below.
            </p>
          </div>
          <div
            class="table-container"
            style="border: thin dashed skyblue; padding:5px; margin-top:15px;">
            <table
              class="table is-fullwidth is-striped"
              style2="background-color:#E0F8F1">
              <thead>
                <th style="color:red">Errors</th>
                <th />
                <th />
              </thead>
              <tbody>
                {#each $questionsWrite as item, i}
                  {#if item.errors > 0}
                    <tr>
                      <td style="color:red">{item.errors}</td>
                      <td>{item.key}</td>
                      <td>{item.val}</td>
                    </tr>
                  {/if}
                {/each}
              </tbody>
            </table>
          </div>
        {/if}
        <button
          class="button is-rounded is-outlined is-hidden-mobile is-medium"
          style="margin: auto;"
          on:click={() => {
            CloseQuiz();
          }}>
          Close
        </button>
      </section>
      <footer class="modal-card-foot" style="padding:5px;">
        <button
          class="button is-rounded is-outlined is-medium"
          style="margin: auto;"
          on:click={() => {
            CloseQuiz();
          }}>
          Close
        </button>
      </footer>
    </div>
  {/if}
</div>
